const DEBUG_TTL_MS = 24 * 60 * 60 * 1000;

function now() {
  return Date.now();
}

function readUntil(key: string) {
  try {
    return Number(localStorage.getItem(key) || 0);
  } catch {
    return 0;
  }
}

function writeUntil(key: string, enabled: boolean) {
  try {
    if (enabled) {
      localStorage.setItem(key, String(now() + DEBUG_TTL_MS));
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}

function active(key: string) {
  const until = readUntil(key);
  if (!until) return false;

  if (until < now()) {
    try {
      localStorage.removeItem(key);
    } catch {}
    return false;
  }

  return true;
}

export function isDebugFlagEnabled(name: 'messages' | 'api' | 'support') {
  if (name === 'messages') {
    return (
      active('intimsync.debug.messages.until') ||
      localStorage.getItem('intimsync.messages.debug') === '1' ||
      localStorage.getItem('intimsync.messages.debugTools') === '1' ||
      String((globalThis as any).__INTIMSYNC_MESSAGES_DEBUG__ || '') === '1'
    );
  }

  if (name === 'api') {
    return (
      active('intimsync.debug.api.until') ||
      localStorage.getItem('intimsync.api.debug') === '1' ||
      String((globalThis as any).__INTIMSYNC_API_DEBUG__ || '') === '1'
    );
  }

  return active('intimsync.debug.support.until');
}

export function enableSupportDebugMode() {
  writeUntil('intimsync.debug.messages.until', true);
  writeUntil('intimsync.debug.api.until', true);
  writeUntil('intimsync.debug.support.until', true);

  try {
    (globalThis as any).__INTIMSYNC_MESSAGES_DEBUG__ = '1';
    (globalThis as any).__INTIMSYNC_API_DEBUG__ = '1';
  } catch {}
}

export function disableSupportDebugMode() {
  writeUntil('intimsync.debug.messages.until', false);
  writeUntil('intimsync.debug.api.until', false);
  writeUntil('intimsync.debug.support.until', false);

  try {
    localStorage.removeItem('intimsync.messages.debug');
    localStorage.removeItem('intimsync.messages.debugTools');
    localStorage.removeItem('intimsync.debugRealtime');
    localStorage.removeItem('intimsync.api.debug');
    delete (globalThis as any).__INTIMSYNC_MESSAGES_DEBUG__;
    delete (globalThis as any).__INTIMSYNC_API_DEBUG__;
  } catch {}
}

export function supportDebugModeEnabled() {
  return (
    isDebugFlagEnabled('messages') ||
    isDebugFlagEnabled('api') ||
    isDebugFlagEnabled('support')
  );
}
